import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { TextButton } from "@src/appV2/redesign/components/TextButton";

interface ShiftHistoryFiltersBottomSheetFooterProps {
  showClearFormButton: boolean;
  onClear: () => void;
  onSubmit: () => void;
  onCancel: () => void;
}

export function ShiftHistoryFiltersBottomSheetFooter(
  props: ShiftHistoryFiltersBottomSheetFooterProps
) {
  const { showClearFormButton, onClear, onCancel, onSubmit } = props;

  return (
    <DialogFooter
      withShadow
      orientation="vertical"
      // Margin top is to avoid having the bottom sheet jump around
      // when the clear button visibility changes. It's 48px because
      // that's the height of the clear button (24px) plus the gap (24px).
      sx={{ gap: 7, marginTop: showClearFormButton ? 0 : 10 }}
    >
      {showClearFormButton && (
        <TextButton size="medium" aria-label="Clear all" onClick={onClear}>
          Clear all
        </TextButton>
      )}

      <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
        <IconButton size="large" variant="outlined" iconType="close" onClick={onCancel} />

        <Button aria-label="Apply filter" variant="contained" size="large" onClick={onSubmit}>
          Apply filter
        </Button>
      </Stack>
    </DialogFooter>
  );
}
